import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityBadges = () => {
  const securityFeatures = [
    {
      icon: 'Shield',
      title: 'SOC 2 Type II',
      description: 'Certified secure infrastructure'
    },
    {
      icon: 'Lock',
      title: 'AES-256 Encryption',
      description: 'Military-grade security'
    },
    {
      icon: 'Eye',
      title: 'Zero-Knowledge',
      description: 'We never see your keys'
    },
    {
      icon: 'Globe',
      title: 'GDPR Compliant',
      description: 'Privacy by design'
    }
  ];

  return (
    <div className="">
      
    </div>
  );
};

export default SecurityBadges;